<div class="modal--unsupported-cases">
  <h1 class="modal__header">{{ modalHeader }}</h1>
  <div class="modal__body">
    <div class="modal__text" *ngFor="let text of modalText">
      {{ text }}
    </div>
  </div>
  <div class="modal__actions modal__actions--inline">
    <button class="button button--blue button--primary modal__button" (click)="goBack()">Go Back</button>
    <button
      *ngIf="isAdvisor"
      class="button button--blue button--secondary button--no-border modal__button"
      (click)="exit()"
    >
      Exit Now
    </button>
  </div>
</div>
